import React, { useState, useEffect } from "react";
import useDebounce from "../../hooks/useDebounce";
import SubItems from "./SubItems";
import { UserSuggestService } from "../../utils/api";
import * as perm from "../../utils/perm";
import { authorGroups } from "../../constants";

const parseValue = value => {
  if (value === "" || value === null || value === undefined) {
    return [];
  }

  if (typeof value === "string") {
    return value.split(",").map(Number);
  }

  return value;
};

const UserItems = ({ onUserSelect, onSelect, name, permissions, ...props }) => {
  const [search, setSearch] = useState("");
  const [options, setOptions] = useState([]);
  const debounceSearch = useDebounce(search, 300);

  const handleSearchChange = e => {
    setSearch(e.target.value);
  };

  const getOptions = () => {
    const extraOptions = [];

    if (perm.allowEditorsGroupFilter(permissions)) {
      extraOptions.push({ name: "Редакторы", value: authorGroups.editors });
    }
    if (perm.allowEditorsNameFilter(permissions)) {
      extraOptions.push({ name: "Владельцы", value: authorGroups.owners });
    }

    return [...extraOptions, ...options];
  };

  useEffect(() => {
    UserSuggestService({ term: debounceSearch })
      .then(data => {
        setOptions(data.users);
      })
      .catch(e => {
        console.log(e);
      });
  }, [debounceSearch]);

  const handleSelect = fltr => {
    const users = getOptions().filter(option =>
      fltr[name].includes(option.value)
    );

    onUserSelect && onUserSelect({ user: users });
    onSelect(fltr, false);
  };

  return (
    <SubItems
      {...props}
      value={parseValue(props.value)}
      options={getOptions()}
      searchValue={search}
      onSearchChange={handleSearchChange}
      onSelect={handleSelect}
      name={name}
      multiply
    />
  );
};

UserItems.defaultProps = {
  permissions: []
};

export default UserItems;
